<template>
  <div>
    <el-form size="small" :inline="true" class="demo-form-inline">
      <el-form-item label="">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          class="m-5"
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{ tag }}
        </el-tag>
        <el-input
          class="input-new-tag m-5"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag m-5" size="small" @click="showInput"> + 添加热词</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import hotKeyApi from '@/api/hotkey.js'

export default {
  name: 'index',
  data () {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
    },
    getData () {
      let self = this
      let param = {}
      hotKeyApi.hotKeyList(param, true).then(res => {
        self.loading = false
        self.dynamicTags = res.data
      }).catch(error => {
        self.loading = false
      })
    },
    handleClose (tag) {
      // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
      let param = {
        hotKey: tag
      }
      hotKeyApi.deleteHotKey(param, true).then(res => {
        this.getData()
      })
    },

    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        // this.dynamicTags.push(inputValue)
        let param = {
          hotKey: this.inputValue
        }
        hotKeyApi.hotKeyAdd(param, true).then(res => {
          this.getData()
        })
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/product/hot/index.vue